const range = (start: number, end: number): number[] => {
    const length = end - start + 1;
    // eslint-disable-next-line no-restricted-properties
    return Array.from({ length }, (_, i) => start + i);
};

interface UsePagesProps {
    last: number;
    first: number;
    current: number;
    boundaryCount: number;
    siblingCount: number;
}

export enum PageControls {
    Previous = -1,
    Next = -2,
    StartEllipsis = -3,
    EndEllipsis = -4,
}

const CURENT_PAGE_AND_ELLIPSIS_POSITION = 2;

export const usePages = ({ last, first, current, boundaryCount, siblingCount }: UsePagesProps): number[] => {
    const count = last - first + 1;

    const startPages = range(first, Math.min(first - 1 + boundaryCount, last));
    const endPages = range(Math.max(count - boundaryCount + first, boundaryCount + first), last);

    const siblingsStart = Math.max(
        Math.min(
            // Настоящее начальное значение для siblings node
            current - siblingCount,
            // Нижняя граница, от max
            last - boundaryCount - siblingCount * 2 - CURENT_PAGE_AND_ELLIPSIS_POSITION
        ),
        // Больше стартовой страницы
        startPages.length > 0 ? startPages[0] + CURENT_PAGE_AND_ELLIPSIS_POSITION : first + 1
    );

    const siblingsEnd = Math.min(
        Math.max(
            // Настоящее конечное значение для siblings node
            current + siblingCount,
            // Верхняя граница, от min
            first + boundaryCount + siblingCount * 2 + CURENT_PAGE_AND_ELLIPSIS_POSITION
        ),
        // Меньше чем endPages
        endPages.length > 0 ? endPages[0] - CURENT_PAGE_AND_ELLIPSIS_POSITION : last - 1
    );

    const startEllipsis =
        // eslint-disable-next-line no-nested-ternary
        siblingsStart > first + boundaryCount + 1
            ? [PageControls.StartEllipsis]
            : boundaryCount + first < last - boundaryCount
              ? [boundaryCount + first]
              : [];

    const endEllipsis =
        // eslint-disable-next-line no-nested-ternary
        siblingsEnd < last - boundaryCount - 1
            ? [PageControls.EndEllipsis]
            : last - boundaryCount > boundaryCount
              ? [last - boundaryCount]
              : [];

    const hasPrevious = first < current && startEllipsis[0] === PageControls.StartEllipsis;
    const hasNext = current < last && endEllipsis[0] === PageControls.EndEllipsis;

    return [
        ...(hasPrevious ? [PageControls.Previous] : []),
        ...startPages,
        ...startEllipsis,
        // Sibling страницы вместе с текущей
        ...range(siblingsStart, siblingsEnd),
        ...endEllipsis,
        ...endPages,
        ...(hasNext ? [PageControls.Next] : []),
    ];
};
